var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 33,
    viewBox: "0 0 48 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5686 18.1918C45.0476 17.2621 46.3294 15.6422 46.5126 13.9378C46.8506 10.9093 45.2026 8.6133 43.1037 7.57093C40.5964 6.31728 42.2727 7.21878 32.666 4.23255C28.0458 2.79578 27.75 1.4576 27.8627 0.499756C26.609 1.47169 26.2287 6.72577 28.398 8.30341C30.6235 9.9233 35.0465 10.2614 40.6105 12.1348C45.4984 13.7547 44.7659 16.7832 43.5686 18.1918Z",
    fill: "url(#paint0_linear_23234_31939)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5509 19.0934C44.1283 18.7976 43.6635 18.5441 43.1705 18.361C36.212 16.4734 35.5922 16.5157 33.2962 15.8537C26.9997 14.0506 27.7604 12.5434 27.6054 11.9377C26.4504 13.4027 26.4222 17.9666 28.5774 19.347C31.1833 21.0091 35.7753 21.5585 41.5929 23.2629C43.4804 23.8263 44.5932 24.4884 45.4242 25.2631C46.3398 26.1364 46.5934 27.4183 45.8891 28.4888C45.2693 29.4326 43.6212 29.2776 41.8041 28.9677C38.5644 28.4325 34.4653 27.3197 33.3103 26.9534C28.1266 25.2631 27.7745 23.6432 27.6195 23.0375C26.4645 24.5025 26.4363 29.0663 28.5915 30.4327C30.2959 31.5173 31.9158 32.1512 35.4232 32.3906C37.9868 32.5737 42.6634 32.7428 44.9453 29.9397C45.1707 29.672 46.9455 28.0803 47.3118 25.3335C47.6357 22.7981 46.4525 20.4175 44.5509 19.0934Z",
    fill: "url(#paint1_linear_23234_31939)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0699 17.2904C41.1547 17.8257 43.169 18.375 43.169 18.375C43.1971 18.3891 43.2394 18.4032 43.2676 18.4173C43.3662 18.3469 43.4648 18.2764 43.5634 18.206C44.7607 16.7974 45.4932 13.7689 40.5912 12.1209C40.2532 12.0082 39.9151 11.8955 39.5911 11.7969C40.9716 12.4448 42.9013 16.0086 39.0699 17.2904Z",
    fill: "url(#paint2_linear_23234_31939)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3524 28.376C40.2538 28.4605 40.1692 28.545 40.0566 28.6155C40.6341 28.7563 41.2257 28.869 41.7751 28.9535C43.6062 29.2493 45.2543 29.4043 45.86 28.4746C46.5643 27.4041 46.3107 26.1222 45.3952 25.2489C43.8739 23.7981 41.9018 23.3191 39.9016 22.7698C41.3806 23.5727 42.6061 26.249 40.3524 28.376Z",
    fill: "url(#paint3_linear_23234_31939)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9472 8.20466C16.0457 6.07768 14.4963 4.23241 12.8623 3.96478C9.94648 3.48585 7.77724 5.88047 6.77713 8.93714C5.57982 12.5854 6.43907 10.1485 3.62187 24.0655C2.26961 30.7564 0.987782 31.193 0.0581055 31.0522C0.987782 32.8552 6.03057 33.3764 7.52369 30.2352C9.07315 27.0095 9.36896 20.6004 11.1297 12.5291C12.6933 5.44381 15.595 6.47209 16.9472 8.20466Z",
    fill: "url(#paint4_linear_23234_31939)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7933 6.7677C17.5115 7.38749 17.2721 8.04953 17.1031 8.76792C15.3282 18.8535 15.3705 19.7409 14.7507 23.0793C13.0463 32.1929 11.6095 31.1083 11.032 31.3478C12.4406 33.024 16.8213 33.024 18.1172 29.8969C19.6949 26.1078 20.1879 19.4733 21.8078 11.0358C22.329 8.28899 22.9628 6.68319 23.7094 5.48588C24.5405 4.14771 25.7659 3.78147 26.7942 4.79566C27.6957 5.68308 27.5549 8.06362 27.2731 10.7118C26.7801 15.4024 25.7378 21.3467 25.3856 23.023C23.7939 30.5308 22.2444 31.052 21.6669 31.2914C23.0755 32.9677 27.4563 32.9677 28.7522 29.8406C29.7805 27.3615 30.3721 25.0232 30.5974 19.9381C30.7524 16.2194 30.8933 9.45813 28.2028 6.162C27.9352 5.83803 26.4139 3.27437 23.7798 2.75319C21.3289 2.28835 19.061 4.02093 17.7933 6.7677Z",
    fill: "url(#paint5_linear_23234_31939)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0986 14.698C16.5916 11.6836 17.1128 8.76783 17.1128 8.76783C17.1268 8.71149 17.1409 8.66923 17.155 8.62697C17.0846 8.48611 17.0282 8.34525 16.9578 8.20439C15.5915 6.47181 12.7038 5.44354 11.1544 12.5288C11.0417 13.0218 10.9431 13.5007 10.8445 13.9797C11.4502 11.9935 14.8449 9.16224 16.0986 14.698Z",
    fill: "url(#paint6_linear_23234_31939)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.721 12.7826C26.8056 12.9235 26.8901 13.0503 26.9605 13.2052C27.0873 12.3601 27.2 11.5149 27.2845 10.7261C27.5662 8.0779 27.7071 5.69737 26.8056 4.80995C25.7773 3.79576 24.5518 4.16199 23.7207 5.50017C22.3403 7.71167 21.8895 10.5711 21.3824 13.4588C22.1149 11.3318 24.6504 9.54285 26.721 12.7826Z",
    fill: "url(#paint7_linear_23234_31939)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23234_31939",
    x1: 52.8315,
    y1: 11.1079,
    x2: 23.4707,
    y2: 8.08507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#4CE5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#076266"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23234_31939",
    x1: 26.8251,
    y1: 22.2079,
    x2: 47.3653,
    y2: 22.2079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23234_31939",
    x1: 42.0984,
    y1: 14.3436,
    x2: 38.2177,
    y2: 19.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_23234_31939",
    x1: 43.1329,
    y1: 24.963,
    x2: 40.6468,
    y2: 33.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_23234_31939",
    x1: 10.8893,
    y1: -4.80065,
    x2: 6.77979,
    y2: 36.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#4CE5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#076266"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_23234_31939",
    x1: 20.8716,
    y1: 32.4441,
    x2: 20.7366,
    y2: 2.69902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_23234_31939",
    x1: 13.0917,
    y1: 10.4063,
    x2: 18.9823,
    y2: 15.0196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#0D777F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177083,
    stopColor: "#118590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_23234_31939",
    x1: 23.5579,
    y1: 8.85614,
    x2: 32.1336,
    y2: 11.3443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#076266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1CAABC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4CE5AE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMb);
export default __webpack_public_path__ + "static/media/logo-mb.dfe721472faaa7475226e131ab1636c7.svg";
export { ForwardRef as ReactComponent };